import React from "react";
import { cn } from "@/lib/utils";
import { Layers } from "lucide-react";
import type { ContextBarProps } from "./ContextBar.types";

export const ContextBar: React.FC<ContextBarProps> = ({ className }) => {
  return (
    <div
      data-testid="context-bar"
      className={cn(
        "flex items-center gap-6 px-4 py-3 rounded-lg mb-6",
        "bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <Layers className="w-4 h-4 text-indigo-500" />
        <span className="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
          Canonical Catalog
        </span>
        <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full border bg-indigo-50 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-400 border-indigo-200 dark:border-indigo-800">
          SmartStore Model
        </span>
      </div>
    </div>
  );
};
